import {METHODS, GET, DELETE} from './methods';
import {fromJS, Record} from 'immutable';
import uuid from 'uuid';

const DEFAULTS = {
  useCache: true,
  method: GET,
  url: [],
  record: null,
};

class Request {
  constructor(params = {}) {
    const {
      useCache,
      method,
      url,
      record,
    } = Object.assign({}, DEFAULTS, params);

    if (!~METHODS.indexOf(method)) {
      throw Error(`Method "${method}" is not valid. It should be one of ${METHODS.join(', ')}`);
    }

    if (method === DELETE && !record) {
      throw Error('To send a DELETE request a record is required.');
    }

    this.uuid = uuid.v4();
    this.useCache = useCache;
    this.method = method;
    this.url = url;
    this.record = record;
  }

  toJS() {
    return {
      uuid: this.uuid,
      useCache: this.useCache,
      method: this.method,
      url: this.url,
      record: (this.record) ? this.record.toJS() : {},
    };
  }

  toImmutable() {
    return fromJS(this.toJS());
  }
}

export default Request;



// WEBPACK FOOTER //
// ./app/javascript/requests/Request.js